import { useCallback, useEffect, useState } from 'react';
import CrudTable from '../../components/CrudTable';
import { db, supabase } from '../../lib/supabase';
import { useAuth } from '../../lib/useAuth';

// QT#8: checklist công việc hằng ngày — tick theo ngày + CRUD danh sách mẫu.
export default function ChecklistAdmin() {
  const { session } = useAuth();
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [templates, setTemplates] = useState([]);
  const [entries, setEntries] = useState({});
  const [loading, setLoading] = useState(true);
  const [tplRefresh, setTplRefresh] = useState(0);

  const load = useCallback(async () => {
    setLoading(true);
    const [tpl, ent] = await Promise.all([
      supabase.from('checklist_templates').select('*').eq('active', true).order('sort_order', { ascending: true }),
      supabase.from('checklist_entries').select('*').eq('entry_date', date),
    ]);
    setTemplates(tpl.data || []);
    setEntries(Object.fromEntries((ent.data || []).map((e) => [e.template_id, e])));
    setLoading(false);
  }, [date]);

  useEffect(() => { load(); }, [load, tplRefresh]);

  const toggle = async (tplId) => {
    const cur = entries[tplId];
    if (!cur) {
      await db.insert('checklist_entries', {
        template_id: tplId, entry_date: date, done: true,
        done_by: session?.user?.id, done_at: new Date().toISOString(),
      });
    } else {
      await db.update('checklist_entries', cur.id, {
        done: !cur.done,
        done_by: session?.user?.id,
        done_at: !cur.done ? new Date().toISOString() : null,
      });
    }
    load();
  };

  const doneCount = templates.filter((t) => entries[t.id]?.done).length;

  return (
    <div>
      <div className="admin-head">
        <h3 style={{ margin: 0 }}>✅ Checklist ngày</h3>
        <div className="row">
          <input type="date" value={date} onChange={(e) => setDate(e.target.value)} style={{ maxWidth: 170 }} />
          <span className="badge badge-best" style={{ fontSize: 13 }}>{doneCount}/{templates.length}</span>
        </div>
      </div>

      {loading ? (
        <div className="loading">Đang tải...</div>
      ) : (
        <div className="card" style={{ marginBottom: 28, padding: 12 }}>
          {templates.length === 0 && <div className="empty">Chưa có đầu việc — thêm ở bảng dưới.</div>}
          {templates.map((tp) => {
            const e = entries[tp.id];
            return (
              <label key={tp.id} className="checkbox-row" style={{ padding: '8px 6px', borderBottom: '1px solid var(--hairline-soft)', margin: 0 }}>
                <input type="checkbox" checked={!!e?.done} onChange={() => toggle(tp.id)} />
                <span style={{ textDecoration: e?.done ? 'line-through' : 'none', color: e?.done ? 'var(--ash)' : 'var(--ink)' }}>
                  {tp.title}
                </span>
                {e?.done && e?.done_at && (
                  <span className="muted" style={{ marginLeft: 'auto', fontSize: 12 }}>
                    {new Date(e.done_at).toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit' })}
                  </span>
                )}
              </label>
            );
          })}
        </div>
      )}

      <CrudTable
        title="🧩 Danh sách đầu việc (template)"
        table="checklist_templates"
        orderBy="sort_order"
        ascending
        defaults={{ active: true, sort_order: 0 }}
        afterChange={() => setTplRefresh((k) => k + 1)}
        columns={[
          { key: 'title', label: 'Đầu việc', type: 'text', required: true },
          { key: 'sort_order', label: 'Thứ tự', type: 'number' },
          { key: 'active', label: 'Đang dùng', type: 'checkbox' },
        ]}
      />
    </div>
  );
}
